// Stage Editor-1:blog 共有 title helper。
//
// - extractTitleFromBody:Markdown-ish body の先頭行から `# タイトル` を抜く。
//   Stage AI-3 で AiBlogPage 内部に居た関数を共有 util に昇格。
// - resolveSaveTitle:title 候補が空の時の 3 段フォールバック。
//   (1) 明示 title (2) body 先頭の markdown 見出し (3) 固定文言

/**
 * body の先頭行から Markdown 見出しを抽出する。
 * 例:`# タイトル` → "タイトル" / `## タイトル` → "タイトル"
 * 該当なしなら null。
 */
export function extractTitleFromBody(body: string): string | null {
  if (!body) return null;
  const firstLine = body.split(/\r?\n/)[0] ?? "";
  const m = firstLine.match(/^#{1,6}\s+(.+?)\s*$/);
  if (m && m[1]) {
    // strip して空じゃなければ返す
    const t = m[1].replace(/^#+\s*/, "").trim();
    if (t.length > 0) return t;
  }
  return null;
}

/**
 * 保存タイトル決定の 3 段フォールバック:
 * 1) 明示 title(空白 trim 後 1 文字以上)
 * 2) extractTitleFromBody(body)
 * 3) 固定文言 "AI生成記事"
 */
export function resolveSaveTitle(title: string, body: string): string {
  const t1 = (title || "").trim();
  if (t1.length > 0) return t1;
  const t2 = extractTitleFromBody(body);
  if (t2 && t2.length > 0) return t2;
  return "AI生成記事";
}